import React, { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { createAdmin } from "../../services/admins"
import { ArrowLeftIcon } from "@heroicons/react/24/outline"

const AdminNewUser = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    username: "",
    password: "",
    role: "ADMIN",
    status: 1
  })
  const [error, setError] = useState("")
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setError("")

    try {
      const res = await createAdmin(formData)
      if (res.status === 200 || res.status === 201) {
        navigate('/admin/system-users')
      } else {
        setError(res.error || "Failed to create user")
      }
    } catch (err) {
      setError("Network error")
    }
    setSubmitting(false)
  }

  return (
    <div className="max-w-xl mx-auto">
      <Link to="/admin/system-users" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 mb-6">
        <ArrowLeftIcon className="w-4 h-4" /> Back to Users
      </Link>

      <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm">
        <h1 className="text-2xl font-bold text-slate-900 mb-6">Invite New Admin</h1>

        {error && <div className="mb-6 p-4 bg-red-50 text-red-600 rounded-xl text-sm">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
            <input
              type="text"
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Username</label>
            <input
              type="text"
              value={formData.username}
              onChange={e => setFormData({ ...formData, username: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Phone Number</label>
            <input
              type="tel"
              value={formData.phoneNumber}
              onChange={e => setFormData({ ...formData, phoneNumber: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              required
              pattern="[0-9]{11}"
              maxLength={11}
            />
            <p className="text-xs text-slate-500 mt-1">11 digits only</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Temporary Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={e => setFormData({ ...formData, password: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              required
              minLength={6}
            />
            <p className="text-xs text-slate-500 mt-1">Minimum 6 characters</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Role</label>
            <select
              value={formData.role}
              onChange={e => setFormData({ ...formData, role: e.target.value })}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              required
            >
              <option value="ADMIN">Admin</option>
              <option value="SUPER_ADMIN">Super Admin</option>
              <option value="SUPER_MODERATOR">Super Moderator</option>
              <option value="MODERATOR">Moderator</option>
            </select>
            <p className="text-xs text-slate-500 mt-1">
              SUPER_ADMIN: Full access to all modules<br/>
              ADMIN: Limited access to core modules<br/>
              SUPER_MODERATOR: Can view all, limited edit<br/>
              MODERATOR: Read-only access
            </p>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Status</label>
            <select
              value={formData.status}
              onChange={e => setFormData({ ...formData, status: parseInt(e.target.value) })}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
              required
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>
          <button disabled={submitting} className="w-full py-3 bg-slate-900 text-white font-bold rounded-xl hover:bg-slate-800 transition">
            {submitting ? 'Creating...' : 'Create User'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default AdminNewUser

